import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery';
import DropDownCellCorrelativa from './myDropDownCellCorrelativa';
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';
import Services7 from './Grid7/services7';
import {getItems7, insertItem , updateItem} from './Grid7/services7';
import FiscalizacaoClassCreateGrid from './FiscalizacaoClassCreateGrid';
import queryString from "query-string";
import ClassGrid7 from './Grid7/ClassGrid7'; 
var optionsAutoOrigem = [];
var token;
var tokenvalue = false
// function myFunctionAutoOrigem() {
//   (async () => {

    

//       const data = {}
//       const AutoOrigemList = await services.apiCall.requestApi(
//         "/Fiscalizacao/GetAutoOrigens",
//           data,
//           "get"
//       );
      
//       if(AutoOrigemList){
//         AutoOrigemList.map((AutoOrigem) => (
//           optionsAutoOrigem.push({text: AutoOrigem.numeroAuto, 
//                                   value: AutoOrigem.idAuto})
//         ));
//       }

//       if(window.location.search != ""){
//         var queryParams = queryString.parse(window.location.search)
//         token = +queryParams.idAuto
//         ClassGrid7.ClassGrid7.getFilter(token)
//       }
// })()};

let dataGrid = [];
class DropDownAutoOrigem extends Component {
  
 static handleChange = e => {
   
    ClassGrid7.ClassGrid7.getFilter(e.value)
    $("#id-DropDownAutoOrigem").addClass(String("idAutoAnterior!"+e.value))

   
  //   (async () => {
  //     const dataAutoGrid = {idAuto : e.value}
  //     const AutoGrid = await services.apiCall.requestApi(
  //     "/Fiscalizacao/GetAutoDetalhe",
  //     dataAutoGrid,
  //     "get"
  //     );

  //     ClassGrid7.ClassGrid7.setState({
  //         data: await getItems7(AutoGrid),
  //         //Columns: this.props.columnList
  //     }); 
  //  })();

  }

  // componentDidMount = () => {
  //   myFunctionAutoOrigem();
  // }

  // render() {

  //   const {
  //     dataItem
  //   } = this.props;
  //   const field = this.props.field || '';

  //   const dataValue = dataItem != null ?  dataItem[field] === null ? '' : dataItem[field] : '';

  //   return (
  //       <DropDownList
  //           style={{width: "100%", class:"custome-drop-down", height:"50px" }}// width: 'max-content'
  //           onChange={this.handleChange}
  //           value={optionsAutoOrigem.find(c => c.value === (dataValue != '' ? dataValue : token))}
  //           data={optionsAutoOrigem}
  //           textField="text"
  //           id='id-DropDownAutoOrigem'
  //       />
  //   );
  // }
}

export default DropDownAutoOrigem;